// LIA em tela cheia, aberta pelo header 2027 ("Conversar com a LIA" e Enter em #o_lia_input, ver ./Lia.js).
// Desenho: docs/lia-header-modal/02-design/ui-v02.md + ui-v03.md. A lógica de chat (transporte, saneamento,
// Salvo v2, regras, gráficos) é o núcleo compartilhado com a tela cloud-bi/lia, fora do 2027.
//
// Camada própria (.lia-fs, z 1055), filha de <body> desde o init: o header pode estar dentro de um <form>
// (product/list) e o .modal do BS4 puxaria o foco do Swal. Nenhum controle tem `name`.
const Core = require('../../../js/components/lia-chat/core');
const Dropdowns = require('./Dropdowns');

const LiaFs = function () {

    const P = 'o_lia_fs_';          // prefixo de id desta instância (F-2)
    const ESPERA_LONGA = 8000;      // A2: "Perguntas maiores podem levar até um minuto." depois de 8 s
    const DESTAQUE = 1200;          // A6: contorno de 1,2 s no Ver de um salvo que já está na conversa

    let t = null, api = null, urlLogin = '', sugestoes = [];
    let R = null;                   // raiz .lia-fs
    const E = {};                   // nós fixos
    let aberto = false, quemAbriu = null, pendente = false, painelAberto = false;
    let cont = 0;                   // contador de ids da instância
    let listaCarregada = false, seqLista = 0;
    const salvos = new Map();       // id → fav (o Ver usa o html que a lista já trouxe)

    const el = Core.el, icone = Core.icone, botao = Core.botao;

    // ── Montagem ──────────────────────────────────────────────────────────────────────────────────
    const montar = function () {
        R = el('div', 'lia-fs');
        R.setAttribute('role', 'dialog');
        R.setAttribute('aria-modal', 'true');
        R.setAttribute('aria-labelledby', P + 'title');
        R.setAttribute('tabindex', '-1');
        R.setAttribute('inert', '');

        // HEAD
        const head = el('div', 'lia-fs-head');
        const marca = el('span', 'lia-fs-mark');
        marca.setAttribute('aria-hidden', 'true');
        marca.appendChild(icone('sparkles-solid'));
        head.appendChild(marca);
        const titulo = el('span', 'lia-fs-title', 'LIA');
        titulo.id = P + 'title';
        head.appendChild(titulo);
        head.appendChild(el('span', 'lia-fs-sub', t('subtitle')));
        const acoes = el('div', 'lia-fs-head-acts');
        E.btSalvos = botao('lia-fs-ob lia-fs-savedbtn');
        E.btSalvos.setAttribute('aria-expanded', 'false');
        E.btSalvos.setAttribute('aria-controls', P + 'saved');
        E.btSalvos.setAttribute('aria-label', t('saved'));
        E.btSalvos.appendChild(icone('bookmark'));
        E.btSalvos.appendChild(el('span', 'lia-fs-ob-tx', t('saved')));
        acoes.appendChild(E.btSalvos);
        E.btFechar = botao('lia-fs-ib lia-fs-close');
        E.btFechar.setAttribute('aria-label', t('close'));
        E.btFechar.appendChild(icone('x'));
        acoes.appendChild(E.btFechar);
        head.appendChild(acoes);
        R.appendChild(head);

        // ROLADOR + coluna
        E.S = el('div', 'lia-fs-scroll');
        E.S.setAttribute('role', 'log');
        E.S.setAttribute('aria-live', 'polite');
        E.col = el('div', 'lia-fs-col');
        E.S.appendChild(E.col);
        R.appendChild(E.S);
        E.col.appendChild(montarBoasVindas());

        // COMPOSITOR
        const comp = el('div', 'lia-fs-comp');
        const compIn = el('div', 'lia-fs-comp-in');
        E.caixa = el('div', 'lia-fs-box');
        E.ta = el('textarea', 'lia-fs-ta');
        E.ta.rows = 1;
        E.ta.placeholder = t('placeholder');
        E.ta.setAttribute('aria-label', t('placeholder'));
        E.ta.setAttribute('autocomplete', 'off');
        E.caixa.appendChild(E.ta);
        E.btEnviar = botao('lia-fs-send');
        E.btEnviar.setAttribute('aria-label', t('send'));
        E.btEnviar.disabled = true;
        E.btEnviar.appendChild(icone('paperplane-solid'));
        E.caixa.appendChild(E.btEnviar);
        compIn.appendChild(E.caixa);
        E.dica = el('div', 'lia-fs-hint', t('hint'));
        compIn.appendChild(E.dica);
        comp.appendChild(compIn);
        R.appendChild(comp);

        // PAINEL SALVOS
        E.pn = el('aside', 'lia-fs-pn');
        E.pn.id = P + 'saved';
        E.pn.setAttribute('aria-labelledby', P + 'saved_t');
        E.pn.setAttribute('inert', '');
        const pnHd = el('div', 'lia-fs-pn-hd');
        E.pnVoltar = botao('lia-fs-pn-back');
        E.pnVoltar.appendChild(el('span', 'lia-fs-pn-back-ic')).appendChild(icone('arrow-left'));
        E.pnVoltar.appendChild(el('span', 'lia-fs-pn-back-tx', t('back')));
        pnHd.appendChild(E.pnVoltar);
        const pnT = el('span', 'lia-fs-pn-t', t('savedTitle'));
        pnT.id = P + 'saved_t';
        pnHd.appendChild(pnT);
        E.pnFechar = botao('lia-fs-ib lia-fs-pn-close');
        E.pnFechar.setAttribute('aria-label', t('close'));
        E.pnFechar.appendChild(icone('x'));
        pnHd.appendChild(E.pnFechar);
        E.pn.appendChild(pnHd);
        E.lista = el('div', 'lia-fs-pn-list');
        E.pn.appendChild(E.lista);
        R.appendChild(E.pn);

        document.body.appendChild(R);
    };

    const montarBoasVindas = function () {
        E.wl = el('div', 'lia-fs-wl');
        const mk = el('span', 'lia-fs-wl-mark');
        mk.setAttribute('aria-hidden', 'true');
        mk.appendChild(icone('sparkles-solid'));
        E.wl.appendChild(mk);
        const h = el('div', 'lia-fs-wl-title', t('welcomeTitle'));
        h.setAttribute('role', 'heading');
        h.setAttribute('aria-level', '2');
        E.wl.appendChild(h);
        E.wl.appendChild(el('p', 'lia-fs-wl-text', t('welcomeText')));
        E.wl.appendChild(el('div', 'lia-fs-wl-label', t('suggestionsLabel')));
        const grade = el('div', 'lia-fs-sugs');
        sugestoes.forEach(function (s) {
            const b = botao('lia-fs-sug');
            b.appendChild(el('span', 'lia-fs-sug-tx', s));
            b.appendChild(icone('arrow-right'));
            b.addEventListener('click', function () { if (!pendente) perguntar(s); });
            grade.appendChild(b);
        });
        E.wl.appendChild(grade);
        return E.wl;
    };

    // ── Compositor ────────────────────────────────────────────────────────────────────────────────
    const ajustarAltura = function () {
        // Teto vem da folha (C14, _lia-fs.scss), nunca literal aqui — LICOES lia-header-modal 11.
        // 'none' / ausente → parseFloat dá NaN → sem teto.
        const teto = parseFloat(window.getComputedStyle(E.ta).maxHeight);
        const limite = isFinite(teto) ? teto : Infinity;
        E.ta.style.height = 'auto';
        E.ta.style.height = Math.min(E.ta.scrollHeight, limite) + 'px';
        E.ta.style.overflowY = E.ta.scrollHeight > limite ? 'auto' : 'hidden';
    };
    const atualizarEnviar = function () {
        E.btEnviar.disabled = pendente || E.ta.value.trim() === '';
    };
    const definirPendente = function (v) {
        pendente = v;
        E.ta.disabled = v;
        E.caixa.classList.toggle('is-disabled', v);
        E.dica.textContent = v ? t('hintWait') : t('hint');
        atualizarEnviar();
    };
    const focarEntrada = function () {
        if (!aberto) return;
        if (!E.ta.disabled) E.ta.focus();
        else R.focus();
    };

    // ── Conversa ──────────────────────────────────────────────────────────────────────────────────
    const tirarBoasVindas = function () {
        if (E.wl && E.wl.parentNode) E.wl.parentNode.removeChild(E.wl);
        E.wl = null;
    };
    const rolarFim = function () { E.S.scrollTop = E.S.scrollHeight; };
    // ui-v03, Regra de rolagem: topo do bloco a 16px do topo do rolador, ou o fim, o que vier antes.
    const rolarPara = function (bloco) {
        const alvo = (bloco.getBoundingClientRect().top - E.S.getBoundingClientRect().top) + E.S.scrollTop - 16;
        E.S.scrollTop = Math.min(alvo, E.S.scrollHeight - E.S.clientHeight);
    };

    const cabecalhoLia = function () {
        const hd = el('div', 'lia-fs-hd');
        const av = el('span', 'lia-fs-av');
        av.setAttribute('aria-hidden', 'true');
        av.appendChild(icone('sparkles-solid'));
        hd.appendChild(av);
        hd.appendChild(el('span', 'lia-fs-name', 'LIA'));
        return hd;
    };

    const bolhaUsuario = function (texto) {
        tirarBoasVindas();
        E.col.appendChild(el('div', 'lia-fs-mu', texto));
    };

    const indicador = function () {
        const w = el('div', 'lia-fs-ai lia-fs-think');
        w.setAttribute('role', 'status');
        w.setAttribute('aria-label', t('thinkingAria'));
        w.appendChild(cabecalhoLia());
        const linha = el('div', 'lia-fs-think-row');
        const pontos = el('span', 'lia-fs-dots');
        pontos.setAttribute('aria-hidden', 'true');
        pontos.appendChild(el('i'));
        pontos.appendChild(el('i'));
        pontos.appendChild(el('i'));
        linha.appendChild(pontos);
        const tx = el('div', 'lia-fs-think-tx');
        tx.appendChild(el('span', '', t('thinking')));
        linha.appendChild(tx);
        w.appendChild(linha);
        E.col.appendChild(w);
        const timer = setTimeout(function () { tx.appendChild(el('span', 'lia-fs-think-slow', t('thinkingSlow'))); }, ESPERA_LONGA);
        return { tirar: function () { clearTimeout(timer); if (w.parentNode) w.parentNode.removeChild(w); } };
    };

    // A5. comCampo: a pergunta voltou ao campo (a linha auxiliar só afirma isso quando é verdade).
    const blocoErro = function (tipo, mensagem, comCampo) {
        const b = el('div', 'lia-fs-err');
        const ic = { server: 'exclamation-circle', conn: 'wifi-slash', session: 'lock-locked', notBuilt: 'exclamation-circle' }[tipo] || 'exclamation-circle';
        b.appendChild(icone(ic, 'lia-fs-err-ic'));
        const tx = el('div', 'lia-fs-err-tx');
        let titulo, aux = '';
        if (tipo === 'server') { titulo = mensagem || t('genericError'); aux = comCampo ? t('backToField') : ''; }
        else if (tipo === 'session') { titulo = t('sessionExpired'); aux = t('sessionLoss'); }
        else if (tipo === 'notBuilt') { titulo = t('notBuilt'); aux = t('rephrase'); }
        else { titulo = t('connError'); aux = comCampo ? t('backToField') : ''; }
        tx.appendChild(el('div', 'lia-fs-err-t', titulo));
        if (aux) tx.appendChild(el('div', 'lia-fs-err-a', aux));
        if (tipo === 'session' && urlLogin) {
            const a = el('a', 'lia-fs-ob lia-fs-login', t('loginAgain'));
            a.href = urlLogin;                       // mesma aba (decisão 4)
            tx.appendChild(a);
        }
        b.appendChild(tx);
        E.col.appendChild(b);
        rolarFim();
    };

    const resposta = function (pergunta, result) {
        const n = ++cont;
        const ans = el('div', 'lia-fs-ai lia-fs-ans');
        const hd = cabecalhoLia();
        const acts = el('div', 'lia-fs-acts');
        const rb = Core.montarRegras(result.rules, P + 'r' + n + '_rules', t);
        if (rb.botao) acts.appendChild(rb.botao);
        acts.appendChild(botaoSalvar(pergunta, result));
        hd.appendChild(acts);
        ans.appendChild(hd);
        if (rb.faixa) ans.appendChild(rb.faixa);
        if (rb.painel) ans.appendChild(rb.painel);
        const prep = Core.prepararCorpo(result.html, 'resposta');
        const res = el('div', 'lia-fs-res');
        res.appendChild(prep.corpo);
        Core.embrulharTabelas(res, 'lia-fs-tw');
        ans.appendChild(res);
        E.col.appendChild(ans);
        Core.desenharGraficosNucleo(ans, result.charts);   // F-9: rolar depois de inserir e desenhar
        rolarPara(ans);
    };

    const categorias = function (opcoes, original) {
        const w = el('div', 'lia-fs-ai lia-fs-catblk');
        w.appendChild(cabecalhoLia());
        const corpo = el('div', 'lia-fs-cat-body');
        corpo.appendChild(el('p', 'lia-fs-cat-p', t('pickCategory')));
        const grupo = el('div', 'lia-fs-cats');
        const botoes = [];
        opcoes.forEach(function (o) {
            const b = botao('lia-fs-cat', o.label);           // rótulo como texto, nunca HTML
            b.addEventListener('click', function () {
                if (pendente) return;
                botoes.forEach(function (x) { x.disabled = true; });
                perguntar(original, { selected_category_id: o.id, selected_category_name: o.label }, {
                    bolha: t('categoryPicked', { nome: o.label }),
                    aoFalhar: function () { botoes.forEach(function (x) { x.disabled = false; }); }
                });
            });
            botoes.push(b);
            grupo.appendChild(b);
        });
        corpo.appendChild(grupo);
        w.appendChild(corpo);
        E.col.appendChild(w);
        rolarPara(w);
    };

    // Envia uma pergunta. ctx: { bolha, aoFalhar } no caso da categoria (a pergunta não foi digitada:
    // não volta ao campo).
    const perguntar = function (msg, extra, ctx) {
        ctx = ctx || {};
        const deCategoria = !!ctx.bolha;
        bolhaUsuario(ctx.bolha || msg);
        const ind = indicador();
        definirPendente(true);
        rolarFim();

        api.chat(Object.assign({ message: msg }, extra || {})).done(function (out) {
            ind.tirar();
            let falhou = out.tipo !== 'ok' && out.tipo !== 'selection';
            let devolveu = false;
            try {
                if (out.tipo === 'ok') resposta(msg, out.result);
                else if (out.tipo === 'selection') categorias(out.options, out.original);
                else {
                    // A8: se o campo já tem texto novo, a pergunta antiga não o sobrescreve (fica na bolha)
                    if (!deCategoria && E.ta.value === '') { E.ta.value = msg; devolveu = true; }
                    blocoErro(out.tipo, out.message, devolveu);
                }
            } catch (err) {
                console.error('[LIA] falha ao mostrar a resposta:', err);
                falhou = true;
                if (!deCategoria && E.ta.value === '') { E.ta.value = msg; devolveu = true; }
                blocoErro('notBuilt', '', devolveu);
            }
            if (falhou && ctx.aoFalhar) ctx.aoFalhar();
            definirPendente(false);
            ajustarAltura();
            atualizarEnviar();
            focarEntrada();
        });
    };

    const enviar = function () {
        if (pendente) return;
        const msg = E.ta.value.trim();
        if (!msg) return;
        E.ta.value = '';
        ajustarAltura();
        perguntar(msg);
    };

    // ── Salvar (A3) ───────────────────────────────────────────────────────────────────────────────
    const swalErro = function (titulo) {
        if (window.Swal) window.Swal.fire({ title: titulo, icon: 'error' });
    };
    const textoFalha = function (out, padraoServer) {
        if (out.tipo === 'session') return t('sessionExpired');
        if (out.tipo === 'conn') return t('connError');
        return out.message || padraoServer;
    };

    const botaoSalvar = function (pergunta, result) {
        const b = botao('lia-fs-ob lia-fs-save');
        const pintar = function (estado) {
            b.textContent = '';
            if (estado === 'salvando') { b.appendChild(icone('bookmark')); b.appendChild(el('span', 'lia-fs-ob-tx', t('saving'))); }
            else if (estado === 'salvo') { b.appendChild(icone('bookmark-solid')); b.appendChild(el('span', 'lia-fs-ob-tx', t('savedDone'))); }
            else { b.appendChild(icone('bookmark')); b.appendChild(el('span', 'lia-fs-ob-tx', t('save'))); }
            b.classList.toggle('is-done', estado === 'salvo');
            b.disabled = estado !== 'salvar';
        };
        pintar('salvar');
        b.addEventListener('click', function () {
            if (b.disabled || !window.Swal) return;
            window.Swal.fire({
                title: window.title_msg_alert,
                text: t('confirmSave'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: window.confirm_msg_alert,
                cancelButtonText: window.cancel_msg_alert,
                reverseButtons: true
            }).then(function (r) {
                if (!r || !r.value) return;
                pintar('salvando');
                api.salvar(String(pergunta).trim(), result).done(function (out) {
                    if (out.tipo === 'ok') {
                        pintar('salvo');
                        if (listaCarregada) carregarLista(true);
                    } else {
                        pintar('salvar');                         // F-6: nunca preso em "Salvando…"
                        swalErro(textoFalha(out, t('saveError')));
                    }
                });
            });
        });
        return b;
    };

    // ── Painel Salvos (A6/A7) ─────────────────────────────────────────────────────────────────────
    const estadoLista = function (tipo) {
        E.lista.textContent = '';
        if (tipo === 'carregando') {
            E.lista.appendChild(el('div', 'lia-fs-pn-loading', t('loading')));
            for (let i = 0; i < 3; i++) {
                const sk = el('div', 'lia-fs-sk');
                sk.setAttribute('aria-hidden', 'true');
                sk.appendChild(el('i'));
                sk.appendChild(el('i'));
                E.lista.appendChild(sk);
            }
            return;
        }
        const st = el('div', 'lia-fs-st');
        if (tipo === 'vazio') {
            st.appendChild(icone('bookmark', 'lia-fs-st-ic is-muted'));
            st.appendChild(el('div', 'lia-fs-st-t', t('emptyTitle')));
            st.appendChild(el('div', 'lia-fs-st-a', t('emptyText')));
        } else if (tipo === 'session') {
            st.appendChild(icone('lock-locked', 'lia-fs-st-ic is-alert'));
            st.appendChild(el('div', 'lia-fs-st-t', t('sessionExpired')));
            if (urlLogin) {
                const a = el('a', 'lia-fs-ob lia-fs-login', t('loginAgain'));
                a.href = urlLogin;
                st.appendChild(a);
            }
        } else {
            st.appendChild(icone('exclamation-circle', 'lia-fs-st-ic is-alert'));
            st.appendChild(el('div', 'lia-fs-st-t', t('listError')));
            const b = botao('lia-fs-ob lia-fs-retry');
            b.appendChild(icone('arrow-rotate-cw-up'));
            b.appendChild(el('span', 'lia-fs-ob-tx', t('retry')));
            b.addEventListener('click', function () { carregarLista(); });
            st.appendChild(b);
        }
        E.lista.appendChild(st);
    };

    // silencioso: depois de Salvar/Remover a lista atual fica na tela até a nova chegar (só a linha
    // removida some); se a recarga falhar, a lista atual continua.
    const carregarLista = function (silencioso) {
        const seq = ++seqLista;
        if (silencioso !== true) estadoLista('carregando');
        api.listar().done(function (out) {
            if (seq !== seqLista) return;                 // resposta velha
            if (out.tipo !== 'ok') {
                if (silencioso === true && E.lista.querySelector('.lia-fs-it')) return;
                estadoLista(out.tipo === 'session' ? 'session' : 'erro');
                return;
            }
            listaCarregada = true;
            salvos.clear();
            if (!out.itens.length) { estadoLista('vazio'); return; }
            E.lista.textContent = '';
            out.itens.forEach(function (fav) {
                if (!fav || fav.id === undefined || fav.id === null) return;
                salvos.set(String(fav.id), fav);
                E.lista.appendChild(itemLista(fav));
            });
            if (!E.lista.children.length) estadoLista('vazio');
        });
    };

    const itemLista = function (fav) {
        const it = el('div', 'lia-fs-it');
        const tx = el('div', 'lia-fs-it-tx');
        tx.appendChild(el('div', 'lia-fs-it-t', String(fav.title || '')));
        const d = Core.dataSalvo(fav.created);
        if (d) tx.appendChild(el('div', 'lia-fs-it-d', d));
        it.appendChild(tx);
        const acts = el('div', 'lia-fs-it-acts');
        const ver = botao('lia-fs-ib lia-fs-view');
        ver.setAttribute('aria-label', t('view'));
        ver.appendChild(icone('eye'));
        const rem = botao('lia-fs-ib lia-fs-del');
        rem.setAttribute('aria-label', t('remove'));
        const remIc = icone('bin');
        rem.appendChild(remIc);
        acts.appendChild(ver);
        acts.appendChild(rem);
        it.appendChild(acts);

        ver.addEventListener('click', function () {
            fecharPainel(true);
            verSalvo(fav);
        });
        rem.addEventListener('click', function () {
            if (!window.Swal) return;
            window.Swal.fire({
                title: window.title_msg_alert,
                text: t('confirmRemove'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: window.confirm_msg_alert,
                cancelButtonText: window.cancel_msg_alert,
                reverseButtons: true
            }).then(function (r) {
                if (!r || !r.value) return;
                ver.disabled = true;
                rem.disabled = true;
                remIc.className = 'ai ai-arrow-rotate-cw-up lia-fs-spin';
                api.remover(fav.id).done(function (out) {
                    if (out.tipo === 'ok') {
                        salvos.delete(String(fav.id));
                        if (it.parentNode) it.parentNode.removeChild(it);
                        if (!E.lista.querySelector('.lia-fs-it')) estadoLista('vazio');
                        carregarLista(true);                    // A6: recarrega depois de Remover
                        return;
                    }
                    ver.disabled = false;
                    rem.disabled = false;
                    remIc.className = 'ai ai-bin';
                    swalErro(out.tipo === 'session' ? t('sessionExpired') : t('removeError'));
                    carregarLista(true);                        // R10: reflete o que outra instância mudou
                });
            });
        });
        return it;
    };

    const verSalvo = function (fav) {
        const ja = E.col.querySelector('[data-fav-source="' + CSS.escape(String(fav.id)) + '"]');
        if (ja) {
            rolarPara(ja);
            ja.classList.remove('is-flash');
            void ja.offsetWidth;
            ja.classList.add('is-flash');
            setTimeout(function () { ja.classList.remove('is-flash'); }, DESTAQUE);
            return;
        }
        tirarBoasVindas();
        const sv = Core.montarBlocoSalvo(fav, { idPainel: P + 'r' + (++cont) + '_rules', t: t, emModal: true });
        E.col.appendChild(sv.bloco);
        sv.pintar();
        rolarPara(sv.bloco);
    };

    const abrirPainel = function () {
        painelAberto = true;
        E.pn.removeAttribute('inert');
        E.pn.classList.add('is-open');
        E.btSalvos.setAttribute('aria-expanded', 'true');
        if (!listaCarregada) carregarLista();
        const alvo = window.getComputedStyle(E.pnVoltar).display !== 'none' ? E.pnVoltar : E.pnFechar;
        alvo.focus();
    };
    const fecharPainel = function (focarSalvos) {
        if (!painelAberto) return;
        painelAberto = false;
        if (focarSalvos && aberto) E.btSalvos.focus();
        E.pn.classList.remove('is-open');
        E.pn.setAttribute('inert', '');
        E.btSalvos.setAttribute('aria-expanded', 'false');
    };

    // ── Abrir / fechar ────────────────────────────────────────────────────────────────────────────
    const fecharDobrasDoShell = function () {
        Dropdowns.fecharTodos();                            // .user-menu tem z 1060, acima do modal
        const $ = window.jQuery;
        if ($ && $.fn && $.fn.dropdown) {
            const $notif = $('.tb-notif .dropdown-menu.show');
            if ($notif.length) $('.tb-notif [data-toggle="dropdown"]').dropdown('toggle');
        }
    };

    const viewport = function () {
        const vv = window.visualViewport;
        if (!vv || !R) return;
        R.style.setProperty('--lia-fs-vh', vv.height + 'px');
        R.style.setProperty('--lia-fs-top', vv.offsetTop + 'px');
    };

    const mostrar = function () {
        fecharDobrasDoShell();
        R.removeAttribute('inert');
        aberto = true;
        viewport();
        R.classList.add('is-open');
    };

    const fechar = function () {
        if (!aberto) return;
        fecharPainel(false);
        aberto = false;
        const volta = quemAbriu;
        quemAbriu = null;
        if (volta && document.contains(volta)) volta.focus();   // antes do inert, senão o foco se perde
        R.classList.remove('is-open');
        R.setAttribute('inert', '');
    };

    // origem: elemento do header que abriu (o foco volta para ele). texto: o que estava no campo do header.
    // Devolve true quando o texto já está a salvo no modal (bolha enviada, ou no campo do modal); só então o
    // header pode ser limpo (spec E1, "Se der errado").
    const abrir = function (origem, texto) {
        if (!R) return false;
        try {
            const msg = String(texto || '').trim();
            if (!aberto) { quemAbriu = origem || null; mostrar(); }
            if (msg) {
                if (pendente) {
                    // E1/A8: não envia e não descarta o que já estava no campo do modal
                    E.ta.value = E.ta.value ? (E.ta.value + '\n' + msg) : msg;
                    ajustarAltura();
                    atualizarEnviar();
                } else {
                    perguntar(msg);
                }
            }
            focarEntrada();
            return true;
        } catch (err) {
            console.error('[LIA] não foi possível abrir a conversa:', err);
            return false;
        }
    };

    // ── Teclado ───────────────────────────────────────────────────────────────────────────────────
    const focaveis = function (escopo) {
        return Array.prototype.filter.call(
            escopo.querySelectorAll('a[href], button:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
            function (n) {
                if (n.closest('[inert]')) return false;
                if (!n.getClientRects().length) return false;
                return window.getComputedStyle(n).visibility === 'visible';
            });
    };

    const ligar = function () {
        E.btFechar.addEventListener('click', fechar);
        E.btSalvos.addEventListener('click', function () { if (painelAberto) fecharPainel(true); else abrirPainel(); });
        E.pnFechar.addEventListener('click', function () { fecharPainel(true); });
        E.pnVoltar.addEventListener('click', function () { fecharPainel(true); });
        E.btEnviar.addEventListener('click', enviar);
        E.ta.addEventListener('input', function () { ajustarAltura(); atualizarEnviar(); });
        E.ta.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); enviar(); }
        });

        // Tab preso: handler no próprio .lia-fs, não no document (ui-v02, Camadas, cond. 5)
        R.addEventListener('keydown', function (e) {
            if (e.key !== 'Tab') return;
            const escopo = painelAberto ? E.pn : R;
            const f = focaveis(escopo);
            if (!f.length) return;
            const atual = document.activeElement;
            const fora = !escopo.contains(atual) || atual === R;
            if (e.shiftKey && (fora || atual === f[0])) { e.preventDefault(); f[f.length - 1].focus(); }
            else if (!e.shiftKey && (fora || atual === f[f.length - 1])) { e.preventDefault(); f[0].focus(); }
        });

        // Esc por camadas: document, fase de BOLHA, sem stopPropagation (R1, F-7). O Swal v11 para a
        // propagação do Esc dele (stopKeydownPropagation), então com Swal aberto o Esc nem chega aqui.
        document.addEventListener('keydown', function (e) {
            if (!aberto || e.key !== 'Escape' || e.defaultPrevented) return;
            if (window.Swal && typeof window.Swal.isVisible === 'function' && window.Swal.isVisible()) return;
            if (painelAberto) fecharPainel(true);
            else fechar();
        });

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', function () { if (aberto) viewport(); });
            window.visualViewport.addEventListener('scroll', function () { if (aberto) viewport(); });
        }
    };

    return {
        // Monta só onde há header (#o_lia_input) e nó de montagem; as views sem header não montam nada (R5).
        init: function () {
            const input = document.getElementById('o_lia_input');
            const mount = document.getElementById('o_lia_fs_mount');
            if (!input || !mount || !window.jQuery) return false;
            const mapa = Core.lerTextos(mount);
            if (!mapa) { console.error('[LIA] data-lia-i18n ausente ou inválido em #o_lia_fs_mount; o modal não foi montado.'); return false; }
            t = Core.tradutor(mapa);
            sugestoes = Array.isArray(mapa.suggestions) ? mapa.suggestions.filter(function (s) { return typeof s === 'string' && s.trim() !== ''; }) : [];
            urlLogin = mount.getAttribute('data-url-login') || '';
            try {
                api = Core.cliente({
                    chat: mount.getAttribute('data-url-chat'),
                    favoriteStore: mount.getAttribute('data-url-favorite-store'),
                    favorites: mount.getAttribute('data-url-favorites'),
                    favoriteBase: mount.getAttribute('data-url-favorite-base')
                });
                montar();
                ligar();
            } catch (err) {
                console.error('[LIA] falha ao montar o modal:', err);
                if (R && R.parentNode) R.parentNode.removeChild(R);
                R = null;
                return false;
            }
            return true;
        },
        abrir: abrir,
        aberto: function () { return aberto; }
    };
}();

module.exports = LiaFs;
